import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Bot, User, FileText } from "lucide-react";
import { WORKSPACE_PREVIEW } from "../portalPreviewData";

export default function WorkspaceOverviewPreview() {
  const { labName, welcomeMessage, auditMirror, documents } = WORKSPACE_PREVIEW;

  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-border bg-gradient-to-br from-primary/5 to-transparent p-6">
        <p className="text-xs font-semibold text-secondary uppercase tracking-wide mb-1">Welcome back</p>
        <h2 className="text-xl font-bold text-foreground mb-1">{labName}</h2>
        <p className="text-sm text-muted-foreground max-w-xl">{welcomeMessage}</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Audit Mirror</CardTitle>
            <p className="text-xs text-muted-foreground">A live, immutable record of every action — AI or human.</p>
          </CardHeader>
          <CardContent className="space-y-3">
            {auditMirror.map((e) => (
              <div key={e.id} className="flex items-start gap-2.5 text-sm">
                {e.tag === "ai" ? (
                  <Bot className="w-4 h-4 mt-0.5 text-secondary shrink-0" />
                ) : (
                  <User className="w-4 h-4 mt-0.5 text-primary shrink-0" />
                )}
                <div className="min-w-0">
                  <p className="text-foreground leading-snug">
                    <span className="font-medium">{e.actor}</span> — {e.action}
                  </p>
                  <p className="text-[11px] text-muted-foreground mt-0.5">{e.time}</p>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">Documents</CardTitle>
            <p className="text-xs text-muted-foreground">Searchable record of every SOP, CAPA, and protocol.</p>
          </CardHeader>
          <CardContent className="space-y-2.5">
            {documents.map((d) => (
              <div key={d.id} className="flex items-center justify-between gap-3 text-sm p-2.5 rounded-lg border border-border/60">
                <div className="flex items-center gap-2 min-w-0">
                  <FileText className="w-4 h-4 text-muted-foreground shrink-0" />
                  <div className="min-w-0">
                    <p className="text-foreground truncate">{d.name}</p>
                    <p className="text-[11px] text-muted-foreground">{d.updated}</p>
                  </div>
                </div>
                <Badge variant={d.status === "in_review" ? "secondary" : "outline"} className="text-[10px] shrink-0">
                  {d.status === "in_review" ? "In Review" : "Current"}
                </Badge>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
